import styled from 'styled-components'

type Props = {
	type?: 'primary' | 'secondary' | 'black' | 'header'
	size?: number
}

const Svg = styled.svg<Props>`
	color: ${({ type = 'black', theme }) => {
		switch (type) {
			case 'secondary':
				return theme.color.secondary
			case 'black':
				return theme.color.logo
			case 'header':
				return theme.color.logoHeader
		}
	}};
	height: 100%;
	width: ${({ size = 160 }) => size}px;
`

export const Logo = (props: Props) => (
	<Svg viewBox='0 0 978.02 236.71' {...props}>
		<title>Subaio logo</title>
		<g id='Layer_2' data-name='Layer 2' fill='currentColor'>
			<g id='Layer_1-2' data-name='Layer 1'>
				<path d='M36.14,228.29q-17.25-8.08-26.69-22.78T0,171.67v-8.58l4-4H42.11l4,4v6.27a24.88,24.88,0,0,0,8.62,19.31q8.61,7.77,23.21,7.76,12.93,0,19.72-6.6t6.8-16.84a20.39,20.39,0,0,0-4.31-13A45.76,45.76,0,0,0,88,149.72q-7.8-4.78-24-13A282,282,0,0,1,31.5,118.19,79.23,79.23,0,0,1,10,96.07Q1,82.54,1,63.39t9.11-33.51A59.36,59.36,0,0,1,35.81,7.76Q52.39,0,73.61,0q22.2,0,39.45,8.42A64.52,64.52,0,0,1,139.92,32q9.62,15.19,9.61,35v6.6l-4,4H107.42l-4-4V67.68a26.3,26.3,0,0,0-8.29-19.81Q86.87,40,72.61,40q-11.94,0-18.73,6.1t-6.8,17a22.24,22.24,0,0,0,4,13.2Q55,81.89,63.33,87t25.2,13.37l7,4q19.23,10.58,30,18.33a67.21,67.21,0,0,1,18.08,19.64q7.27,11.88,7.29,28.72,0,30-20.39,47.71T76.26,236.38Q53.38,236.38,36.14,228.29Z' />
				<path d='M220.15,227.14a65.66,65.66,0,0,1-26.69-25.92Q184,184.56,184,162.76V6.6l4-4h38.79l4,4V165.07q0,14.2,8,22.78t21.22,8.58q13.26,0,21.22-8.58t8-22.78V32.81l19.7-30.17h23.07l4,4V162.76q0,21.78-9.45,38.46a65.66,65.66,0,0,1-26.69,25.92q-17.25,9.24-39.79,9.24T220.15,227.14Z' />
				<path d='M502.12,217.4q-20.4,16.33-52.55,16.34H396.26l-24.94-30.17V6.6l4-4h69.29q35.48,0,55,15.68T519.19,66q0,32.68-25.53,47.21-1.65,1-.33,2,29.18,16.52,29.18,54.47Q522.51,201.06,502.12,217.4ZM418.07,44.24V96.07l1.66,1.65h25.19q13.26,0,20.89-7.26t7.63-20.14q0-13.2-7.46-20.47t-21.06-7.26H419.73ZM468.3,185.7q7.45-7.75,7.46-21.95t-7.46-22.29q-7.46-8.09-20.72-8.08H419.73L418.07,135v56.78l1.66,1.65h27.85Q460.83,193.46,468.3,185.7Z' />
				<path d='M665,230.44l-7.62-32.36-1.66-1.32h-62L592,198.08l-7.62,32.36-4.31,3.3H540l-3.32-4.29L596.34,5.94,601,2.64h48.08l4.64,3.3,59.68,223.51-3.31,4.29H669.62ZM625.19,63.06h-2L601,158.8l1.66,2h43.77l1.66-2Z' />
				<path d='M742.94,2.64H766l19.7,30.17v197l-4,4h-38.8l-4-4V6.6Z' />
				<path d='M860.49,227.47a66.17,66.17,0,0,1-27-26.09q-9.62-16.83-9.61-39.28V74.28q0-22.11,9.61-39a66.27,66.27,0,0,1,27-26.08Q877.89,0,900.77,0t40.45,9.24a66.13,66.13,0,0,1,27.19,26.08q9.62,16.84,9.61,39V162.1q0,22.46-9.61,39.28a66,66,0,0,1-27.19,26.09q-17.58,9.24-40.45,9.24T860.49,227.47ZM923,187.68q8.29-9.08,8.29-23.6V73q0-14.85-8.29-23.93T900.77,40q-13.6,0-21.88,9.08T870.6,73v91.12q0,14.53,8.29,23.6t21.88,9.08Q914.69,196.76,923,187.68Z' />
			</g>
		</g>
	</Svg>
)
